var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-08-25
 * @brief My Account 컴포넌트
 *
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
import * as HttpUtil from "../../utils/api/HttpUtil";
import UserWithdrawal from "./UserWithdrawal";
import { useAsync } from "react-async";
/**
 * @brief My Account 컴포넌트
 * @param
 * @returns react components
 */
export default function MyAccount(props) {
    // recoli
    const userInfo = props.userInfo;
    //
    const [display, setDisplay] = useState(false);
    const [password, setPassword] = useState("");
    // 새비밀번호
    const [passwordNew, setPasswordNew] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [zoneName, setZoneName] = useState("");
    const [department, setDepartment] = useState("");
    const [classificationItem, setclassificationItem] = useState([]);
    const [classificationCode, setClassificationCode] = useState("");
    /*  const [isAgreeMailReceipt, setIsAgreeMailReceipt] = useState(false);
     const strAgreeMailReceipt = (isAgreeMailReceipt) ? "true" : "false"; */
    const [resErrorCode, setResErrorCode] = useState(200);
    const [resErrorMsg, setResErrorMsg] = useState([{ field: "", msg: "" }]);
    const [errorList, setErrorList] = useState([]);
    const [errorListNew, setErrorListNew] = useState([]);
    const [resPasswordMsg, setResPasswordMsg] = useState("");
    // 새비밀번호
    const [resPassworNewdMsg, setResPasswordNewMsg] = useState("");
    const [resConfirmPasswordMsg, setResConfirmPasswordMsg] = useState("");
    // 업종구분
    const { data: data } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/user/classification`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setclassificationItem(data.body);
            }
            else { // api if need error handle
                setErrorList(data.errorList);
            }
        }
    }, [data]);
    //
    function displayChang(e) {
        var btnComment = document.getElementById("pop-myaccount-pass");
        if (display === false) {
            setDisplay(true);
        }
        else {
            setDisplay(false);
            if (!CUTIL.isnull(btnComment))
                btnComment.setAttribute("style", "");
            setPassword("");
            setPasswordNew("");
            setConfirmPassword("");
            setResPasswordNewMsg("");
            setResPasswordMsg("");
            setResConfirmPasswordMsg("");
        }
    }
    useEffect(() => {
        setClassificationCode(userInfo.classificationCode);
        setPhoneNumber(userInfo.phoneNumber);
        setZoneName(userInfo.zoneName);
        setDepartment(userInfo.department);
        // setIsAgreeMailReceipt(userInfo.agreeMailReceipt);
    }, [userInfo]);
    function onClickSave(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "PUT",
                appPath: "/api/v2/user",
                appQuery: {
                    userId: userInfo.userId,
                    userName: userInfo.userName,
                    phoneNumber: phoneNumber,
                    // companyName: companyName,
                    zoneName: zoneName,
                    // email: userInfo.email,
                    department: department,
                    classificationCode: classificationCode, // 20221031 업종 추가
                    // agreeMailReceipt: strAgreeMailReceipt
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    var btnCommentClose = document.getElementById("pop-myaccount");
                    var body = document.body;
                    var dimm = document.querySelector(".dimm");
                    if (!CUTIL.isnull(btnCommentClose))
                        btnCommentClose.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                    alert("정보가 변경되었습니다.");
                }
                else {
                    setResErrorCode(data.codeNum);
                    setResErrorMsg(data.errorList);
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function handleSetPhoneNumber(e) {
        setErrorList(errorList.filter((err) => (err.field !== "phoneNumber")));
        setPhoneNumber(e.target.value);
    }
    function handleSetZoneName(e) {
        setErrorList(errorList.filter((err) => (err.field !== "zoneName")));
        setZoneName(e.target.value);
    }
    /*   function handlesetIsAgreeMailReceipt(val) {
  
          setIsAgreeMailReceipt(val);
      } */
    function handleSetPassword(val) {
        setErrorList(errorList.filter((err) => (err.field !== "password")));
        setPassword(val);
    }
    //password 확인
    function OnChangepasswordNew(e) {
        setErrorListNew(errorListNew.filter((err) => (err.field !== "password")));
        setPasswordNew(e.target.value);
    }
    function OnChangeConfirmPasswordNew(e) {
        setErrorListNew(errorListNew.filter((err) => (err.field !== "confirmPassword")));
        setConfirmPassword(e.target.value);
    }
    function onClickValid(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/auth/password/valid`,
                appQuery: {
                    password: password
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setResPasswordMsg(data.data.msg);
                    // 신규 비밀번호 체크
                    passWordChang(e, data.body.token);
                }
                else {
                    setResErrorCode(data.codeNum);
                    setResErrorMsg(data.errorList);
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function passWordChang(e, token) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if ((passwordNew == confirmPassword)) {
                data = yield HttpUtil.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/api/v2/auth/password/change`,
                    appQuery: {
                        "password": passwordNew,
                        "token": token
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        alert("비밀번호가 변경 되었습니다. ");
                        displayChang(e);
                    }
                    else {
                        setResErrorCode(data.codeNum);
                        setResErrorMsg(data.errorList);
                        if (passwordNew == '') {
                            setErrorListNew(data.errorList);
                        }
                        else {
                            setErrorListNew([
                                { field: "password", msg: data.errorList[0].msg },
                                { field: "confirmPassword", msg: data.errorList[0].msg },
                            ]);
                        }
                    }
                }
            }
            else {
                setErrorListNew([
                    { field: "password", msg: "비밀번호가 일치하지 않습니다." },
                    { field: "confirmPassword", msg: "비밀번호가 일치하지 않습니다." },
                ]);
            }
        });
    }
    function closePop(e) {
        var btnCommentClose = document.getElementById("pop-myaccount");
        var body = document.body;
        var dimm = document.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
    }
    function classificationCodeSel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/user/classification`,
                appQuery: {},
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setclassificationItem(data.body);
                }
                else { // api if need error handle
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function handleSetclassIficationCode(code) {
        setErrorList(errorList.filter((err) => (err.field !== "classificationId")));
        setClassificationCode(code);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-myaccount", className: "popup-layer js-layer layer-out hidden popup-basic myaccount" },
            (!display) ?
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null, "My Account"),
                    React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => closePop(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")))
                :
                    // 비밀번호 수정 화면
                    React.createElement("div", { className: "popup__head" },
                        React.createElement("h1", null, "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD"),
                        React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => displayChang(e) },
                            React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            (!display) ?
                React.createElement("div", { className: "popup__body" },
                    React.createElement("form", { action: "", method: "", name: "popmyaccount" },
                        React.createElement("ul", { className: "form__input mt-9" },
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userId2" }, "\uC0AC\uC6A9\uC790 \uD0C0\uC785"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("div", { className: "radioBox" },
                                        React.createElement("label", { htmlFor: "rd1" },
                                            React.createElement("input", { type: "radio", id: "rd1", name: "rd", disabled: true, checked: (userInfo.role == "ROLE_ADMIN") ? true : false }),
                                            "Admin"),
                                        React.createElement("label", { htmlFor: "rd2" },
                                            React.createElement("input", { type: "radio", id: "rd2", name: "rd", disabled: true, checked: (userInfo.role == "ROLE_ENGINEER") ? true : false }),
                                            "Engineer"),
                                        React.createElement("label", { htmlFor: "rd3" },
                                            React.createElement("input", { type: "radio", id: "rd3", name: "rd", disabled: true, checked: (userInfo.role == "ROLE_USER") ? true : false }),
                                            "User")))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userId2" }, "E-mail (\uC544\uC774\uB514)"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "userId2", disabled: true, value: userInfo.email }))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userpw" }, "\uBE44\uBC00\uBC88\uD638"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("button", { type: "button", className: "btn btn-txt js-open", "data-pop": "pop-myaccount-pass", onClick: (e) => displayChang(e) },
                                        React.createElement("span", null, "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD")))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "username3" }, "\uC774\uB984"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "username3", disabled: true, value: userInfo.userName }))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userphone2", className: "star" }, "\uC5F0\uB77D\uCC98"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "tel", id: "userphone2", name: "phone", placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694", value: phoneNumber, onChange: (e) => handleSetPhoneNumber(e), className: (errorList.filter(err => (err.field === "phoneNumber")).length > 0) ? "input-error" : "" }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "phoneNumber")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userId3" }, "\uD68C\uC0AC"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "userId3", disabled: true, value: userInfo.companyName }))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "userId4", className: "star" }, "\uC0AC\uC5C5\uC7A5"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "userId4", name: "zone", placeholder: "\uC0AC\uC5C5\uC7A5\uC744 \uC785\uB825\uD558\uC138\uC694", value: zoneName, onChange: (e) => handleSetZoneName(e), className: (errorList.filter(err => (err.field === "zoneName")).length > 0) ? "input-error" : "" }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "zoneName")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "part" }, "\uBD80\uC11C"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "part", value: department, onChange: (e) => setDepartment(e.target.value) }))),
                            React.createElement("li", null,
                                React.createElement("label", { htmlFor: "part", className: "star" }, "\uC5C5\uC885"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "classificationId")).length > 0) ? "input-error" : ""}`, onClick: (e) => classificationCodeSel(e) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { className: "selected-value" }, userInfo.classification),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, classificationItem.map((list, idx) => (React.createElement("li", { key: "class_" + idx.toString(), className: "option", onClick: (e) => handleSetclassIficationCode(list.code) }, list.classification))))),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "classificationId")).map((err) => err.msg)))))))
                :
                    // 비밀번호 수정화면
                    React.createElement("div", { className: "popup__body" },
                        React.createElement("form", { action: "", method: "", name: "popmyaccount" },
                            React.createElement("ul", { className: "form__input mt-9" },
                                React.createElement("li", null,
                                    React.createElement("label", { htmlFor: "userPw1" }, "\uD604\uC7AC \uBE44\uBC00\uBC88\uD638"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "password", id: "userPw1", value: password, onChange: (e) => handleSetPassword(e.target.value), className: (errorList.filter(err => (err.field === "password")).length > 0) ? "input-error" : (resPasswordMsg == "success") ? "input-ok" : "" }),
                                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "password")).map((err) => err.msg)))),
                                React.createElement("li", null,
                                    React.createElement("label", { htmlFor: "userPw2" }, "\uC0C8 \uBE44\uBC00\uBC88\uD638"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "password", id: "userPw2", value: passwordNew, placeholder: "10~16\uC790 \uD14D\uC2A4\uD2B8, \uC601\uBB38/\uC22B\uC790\uB97C \uD3EC\uD568\uD558\uC5EC \uC785\uB825\uD558\uC138\uC694.", onChange: (e) => OnChangepasswordNew(e), className: (errorListNew.filter(err => (err.field === "password")).length > 0) ? "input-error" : "" }),
                                        React.createElement("p", { className: "input-errortxt" }, errorListNew.filter(err => (err.field === "password")).map((err) => err.msg)))),
                                React.createElement("li", null,
                                    React.createElement("label", { htmlFor: "userPw3" }, "\uC0C8 \uBE44\uBC00\uBC88\uD638 \uD655\uC778"),
                                    React.createElement("div", { className: "input__area" },
                                        (!passwordNew) &&
                                            React.createElement("input", { type: "text", disabled: true, readOnly: true }),
                                        (passwordNew) &&
                                            React.createElement("input", { type: "password", id: "userPw3", value: confirmPassword, placeholder: "10~16\uC790 \uD14D\uC2A4\uD2B8, \uC601\uBB38/\uC22B\uC790\uB97C \uD3EC\uD568\uD558\uC5EC \uC785\uB825\uD558\uC138\uC694.", onChange: (e) => OnChangeConfirmPasswordNew(e), className: (errorListNew.filter(err => (err.field === "confirmPassword")).length > 0) ? "input-error" : "" }),
                                        React.createElement("p", { className: "input-errortxt" }, errorListNew.filter(err => (err.field === "confirmPassword")).map((err) => err.msg))))))),
            (!display) ?
                React.createElement("div", { className: "popup__footer " },
                    React.createElement("button", { type: "button", className: "bg-linegray js-open", "data-pop": "pop-withdrawal", onClick: (e) => CUTIL.jsopen_Popup(e) },
                        React.createElement("span", { "data-pop": "pop-withdrawal" }, "\uD0C8\uD1F4\uD558\uAE30")),
                    React.createElement("button", { type: "button", onClick: (e) => onClickSave(e) },
                        React.createElement("span", null, "\uC800\uC7A5")))
                :
                    React.createElement("div", { className: "popup__footer" },
                        React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => displayChang(e) },
                            React.createElement("span", null, "\uCDE8\uC18C")),
                        React.createElement("button", { type: "button", onClick: (e) => onClickValid(e) },
                            React.createElement("span", null, "\uC800\uC7A5")))),
        React.createElement(UserWithdrawal, { userId: userInfo.userId })));
}
